<template>
<div>
    <div class="col-md-12">
        <div class="row" style="margin-top: 20px">
            <div class="col-md-6">
                <h3 class="page-header">
                    <i class="fa fa-motorcycle animated bounceInDown show-info"></i>
                    <span>My Deliveries</span>
                </h3>
            </div>
            <div class="col-md-6 text-right">
                <button class="btn btn-sm" :class="done == 0 ? 'btn-primary' : 'btn-default'" @click="setTab(0)">To Deliver</button>
                <button class="btn btn-sm" :class="done == 1 ? 'btn-primary' : 'btn-default'" @click="setTab(1)">Completed</button>
                <span class="control-label" style="margin-left:10px">Total:</span>
                <span class="badge bg-danger">{{ orders.length }}</span>
                <button @click="refresh()" class="btn btn-refresh"><i class="fa fa-refresh"></i></button>
            </div>
        </div>
    </div>
    <div class="col-md-12" v-if="done == 1">
        <div class="panel">
            <div class="panel-body flex-row" style="gap:8px;align-items:center;flex-wrap:wrap">
                <label class="control-label" style="margin:0">Dispatched from</label>
                <input class="form-control input-small" type="date" v-model="fromdate" style="width:160px"/>
                <label class="control-label" style="margin:0">to</label>
                <input class="form-control input-small" type="date" v-model="todate" style="width:160px"/>
                <button class="btn btn-primary btn-sm" @click="refresh()">Search</button>
                <button class="btn btn-default btn-sm" @click="fromdate = ''; todate = ''; refresh()">Clear</button>
            </div>
        </div>
    </div>
    <div class="col-md-12">
        <p class="text-muted" v-if="done == 0">
            {{ isadmin ? 'Orders of all delivery boys.' : 'Orders assigned to you for delivery.' }} Ready to dispatch orders show here once approved;
            after the serial no. is entered and the order is dispatched, take the product and click Accept
            with the delivery time.
        </p>
        <div class="panel">
            <div class="table-responsive panel-body">
                <table class="table users-table table-condensed table-hover table-bordered table-sm">
                    <thead class="table-font" style="font-size:13px;">
                        <tr>
                            <th>#</th>
                            <th>Order No.</th>
                            <th>Customer</th>
                            <th>Mobile</th>
                            <th>Address</th>
                            <th>Product</th>
                            <th>Remark</th>
                            <th v-if="isadmin">Delivery Boy</th>
                            <th>Dispatcher</th>
                            <th>Status</th>
                            <th v-if="done == 0">Action</th>
                        </tr>
                    </thead>
                    <tbody class="table-font" style="font-size:13px;">
                        <tr v-if="!loading && orders.length == 0">
                            <td :colspan="(done == 0 ? 10 : 9) + (isadmin ? 1 : 0)" class="text-center">No orders</td>
                        </tr>
                        <tr v-for="(item, index) in orders" :key="item.id">
                            <td>{{ index + 1 }}</td>
                            <td>{{ item.complaintno }}<br>{{ moment(item.created_at).format('DD-MM-YYYY') }}</td>
                            <td>
                                <span v-if="item.customer">{{ item.customer.name }}<br>{{ item.customer.generatedid }}</span>
                                <span v-else>{{ item.customername }}</span>
                            </td>
                            <td>
                                <display-mobiles v-if="item.customer" :mobiles="item.customer.mobiles"></display-mobiles>
                                <span v-else>{{ item.customermobile }}</span>
                            </td>
                            <td>
                                <display-first-address v-if="item.customer" :addresses="item.customer.addressess"></display-first-address>
                                <span v-else>{{ item.customeraddress }}</span>
                            </td>
                            <td>
                                {{ item.product?.category?.name }} {{ item.product?.name }}
                                <div v-if="item.serialno" style="font-size:11px">Serial no.: {{ item.serialno }}</div>
                            </td>
                            <td>{{ item.remark }}</td>
                            <td v-if="isadmin">{{ item.deliveryboy?.name || '-' }}</td>
                            <td>{{ item.followby?.name || '-' }}</td>
                            <td>
                                <span class="label" :class="statusClass(item.status)">{{ statusLabel(item.status) }}</span>
                                <div v-if="item.estimated_delivery_at" style="font-size:11px">
                                    Delivery by: {{ moment(item.estimated_delivery_at).format('DD-MM-YYYY hh:mm A') }}
                                </div>
                                <div v-if="item.status == 6" style="font-size:11px">
                                    <span v-if="item.return_receivedbyid > 0" style="color:green">
                                        Returned to store ({{ item.returnreceivedby?.name }})
                                    </span>
                                    <span v-else style="color:#c0392b">Return the product to the store</span>
                                </div>
                            </td>
                            <td v-if="done == 0" style="min-width:230px">
                                <div v-if="savingid == item.id">Saving...</div>
                                <div v-else-if="!mine(item)" class="text-muted">Only the delivery boy can update</div>
                                <div v-else-if="item.status == 1" style="color:#b16b00">
                                    Waiting for {{ item.followby?.name || 'the dispatcher' }} to dispatch
                                </div>
                                <div v-else-if="item.status == 3">
                                    <input class="form-control input-small" type="datetime-local" v-model="etas[item.id]"/>
                                    <button class="btn btn-primary btn-xs" style="margin-top:4px" @click="accept(item)">Accept</button>
                                    <button class="btn btn-danger btn-xs" style="margin-top:4px" @click="reject(item)">Reject</button>
                                </div>
                                <div v-else-if="item.status == 4">
                                    <button class="btn btn-success btn-xs" @click="delivered(item)">Delivered</button>
                                    <button class="btn btn-danger btn-xs" @click="reject(item)">Reject</button>
                                </div>
                                <input v-if="mine(item) && (item.status == 3 || item.status == 4)" class="form-control input-small"
                                    style="margin-top:4px" type="text" v-model="reasons[item.id]"
                                    placeholder="Reason (required to reject)"/>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import DisplayFirstAddress from '../../components/address/DisplayFirstAddress.vue'
import DisplayMobiles from '../../components/mobile/DisplayMobiles.vue'
const STATUS = {
    1: ['Ready to dispatch', 'label-default'],
    3: ['Dispatched - to accept', 'label-warning'],
    4: ['On the way', 'label-primary'],
    5: ['Delivered', 'label-success'],
    6: ['Rejected', 'label-danger']
}
export default {
    components: { DisplayFirstAddress, DisplayMobiles },
    data() {
        return {
            moment: moment,
            orders: [],
            loading: false,
            done: 0,
            savingid: null,
            etas: {},
            reasons: {},
            fromdate: '',
            todate: ''
        }
    },
    computed: {
        ...mapGetters(['loggedinuser']),
        // admins get every delivery boy's orders from the backend (role > 1)
        isadmin() {
            return (this.loggedinuser?.role ?? 0) > 1
        }
    },
    mounted() {
        this.refresh()
    },
    methods: {
        mine(item) {
            return this.loggedinuser != null && item.deliveryboyid == this.loggedinuser.id
        },
        statusLabel(status) {
            return STATUS[status]?.[0] ?? ''
        },
        statusClass(status) {
            return STATUS[status]?.[1] ?? 'label-default'
        },
        setTab(done) {
            this.done = done
            this.refresh()
        },
        refresh() {
            this.loading = true
            this.$store.commit('assignloadingstatus', 1)
            const param = { done: this.done }
            if (this.done == 1) {
                param.fromdate = this.fromdate
                param.todate = this.todate
            }
            this.$http.post('api/vsdigi/leads/orders/my-deliveries', param)
                .then((response) => {
                    this.orders = response.data || []
                })
                .catch((err) => {
                    console.log(err)
                    this.$notify({ text: err.response?.data?.message || 'Unable to load orders', type: 'error' })
                })
                .finally(() => {
                    this.loading = false
                    this.$store.commit('assignloadingstatus', 0)
                })
        },
        accept(item) {
            const eta = this.etas[item.id]
            if (!eta) {
                this.$notify({ text: 'Enter the delivery time to accept', type: 'error' })
                return
            }
            this.save(item, { status: 4, estimated_delivery_at: moment(eta).format('YYYY-MM-DD HH:mm:ss') },
                'Accepted, order is on the way')
        },
        delivered(item) {
            if (!confirm('Mark this order as delivered?')) return
            this.save(item, { status: 5 }, 'Order delivered')
        },
        reject(item) {
            const reason = (this.reasons[item.id] || '').trim()
            if (!reason) {
                this.$notify({ text: 'Enter the reason to reject', type: 'error' })
                return
            }
            if (!confirm('Reject this order?')) return
            this.save(item, { status: 6, detail: reason }, 'Order rejected')
        },
        save(item, param, message) {
            this.savingid = item.id
            this.$http.post('api/vsdigi/leads/orders/my-deliveries/status', { id: item.id, ...param })
                .then(() => {
                    this.$notify({ text: message, type: 'success' })
                    this.refresh()
                })
                .catch((err) => {
                    console.log(err)
                    this.$notify({ text: err.response?.data?.message || 'Unable to update the order', type: 'error' })
                })
                .finally(() => {
                    this.savingid = null
                })
        }
    }
}
</script>
